// Convert an array of user groups of the form: ["Admins", "Teachers", "Students"]
// to a string of the form: "Admin / Teacher / Student", without the s on the end of each group.
export const formatUserGroups = (userGroups: string[]) => {
  const formattedUserGroups = (userGroups || []).map((group) => {
    if (group.endsWith('s')) {
      return group.slice(0, -1);
    }
    return group;
  });
  return formattedUserGroups.join(' / ');
};
